<template>
  <div class="comentario-card">
    <div class="mensagem">
      {{ comentario.mensagem }}
    </div>
    <div class="autor">
      <span class="autor-nome"> {{ nomeAutor }}</span> 
      <span class="data">em {{ dataFormatada }}</span>
    </div>
  </div>
</template>

<script>
import { parseISO, format } from "date-fns";

export default {
  name: "ExibirComentario",
  props: {
    comentario: {
      type: Object,
      required: true
    }
  },
  computed: {
    nomeAutor() {
      return this.comentario?.usuario?.nome || "Autor desconhecido";
    },
    mensagemSegura() {
      return this.comentario?.mensagem || "Mensagem não disponível.";
    },
    dataFormatada() {
      if (!this.comentario?.created_at) return "data indisponível";
      const data = parseISO(this.comentario.created_at);
      return format(data, "dd/MM/yyyy 'às' HH:mm:ss");
    }
  },
  methods: {
    formatarData(value) {
      return format(parseISO(value), "dd/MM/yyyy");
    }
  }
};
</script>

<style scoped>
.comentario-card {
  background-color: #dbdbdb;
  padding: 1.2rem 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 5px 15px rgba(0, 85, 22, 0.6);
  margin-bottom: 0.75rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  word-break: break-word;
  min-height: 80px;
}

.mensagem {
  font-size: 1rem;
  color: #222 !important;
  text-align: left;
  white-space: pre-wrap;
  margin-bottom: 0.8rem;
  visibility: visible !important;
  opacity: 1 !important;
  height: auto !important;
  display: block !important;
}

.autor {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-top: auto;
  font-size: 0.9rem;
  color: #333;
  font-style: italic;
}

.autor .data {
  font-style: normal;
  margin-left: 0.4rem;
  color: #666;
}



</style>
